// Enums

// TODO

export enum Status {
  ONLINE = "ONLINE",
  OFFLINE = "OFFLINE",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export enum MonitorType {
  Checkpoint = "CHECKPOINT",
  FlyExterminator = "FLY_EXTERMINATOR",
  IoT = "IOT_MONITOR",
}

export enum MonitorIoTClass {
  IoTGateway = "GATEWAY",
  IoTSim = "SIM",
  IoTPortal = "PORTAL",
  IoTSensor = "SENSOR",
  IoTPestMonitor = "PEST_MONITOR",
  IoTPestMonitorWithSim = "PEST_MONITOR_WITH_SIM",
}

export enum PestCategoryKey {
  GermanRoach = "german-roach",
  OrientalRoach = "oriental-roach",
  Mouse = "mouse",
  Rat = "rat",
  Moth = "moth",
  RiceWeevil = "rice-weevil",
  Fly = "fly",
  Pheromone = "pheromone",
  Ant = "ant",
  Bird = "bird",
}

export enum PestTypeKey {
  MouseNonTox = "mouse-non-tox",
  MouseTox = "mouse-tox",
  RatNonTox = "rat-non-tox",
  RatTox = "rat-tox",
  MouseTrapALoRa = "mouse-trap-alora",
  RatTrapALoRa = "rat-trap-alora",
  CrawlingInsects = "indicator-crawling-insects",
  BeetleAttractant = "beetle-attractant",
  MothTrapPheromone = "moth-trap-pheromone",
  FlyExterminator = "fly-exterminator",
  BirdVisualCheckPoint = "bird-visual-check-point",
}

export enum RiskTypeKey {
  Unspecified = "",
  Rodent = "rodent",
  CrawlingInsect = "crawling-insect",
  FlyingInsect = "flying-insect",
  Bird = "bird",
}

export enum RiskLevelKey {
  Unspecified = "",
  None = "none",
  Low = "low",
  Medium = "medium",
  High = "high",
}

export enum QPMSearchParams {
  CollapsibleAreasOpen = "open",
}

export enum DocumentDocType {
  Requirement = "BA",
  Calculation = "K",
  Offer = "AN",
}

export enum ConsumableTypeKey {
  Adhesive = "ADHESIVE",
  Tube = "TUBE",
  Bait = "BAIT",
  LurePheromone = "LURE_PHEROMONE",
  Battery = "BATTERY",
  Sim = "SIM",
  Cartridge = "CARTRIDGE",
  FilterMembrane = "FILTER_MEMBRANE",
  SparePart = "SPARE_PART",
  Cleaning = "CLEANING",
  MountingMaterial = "MOUNTING_MATERIAL",
  Calibration = "CALIBRATION",
}

export enum ConsumableUnitKey {
  Item = "item",
  Gram = "gram",
  Milliliters = "milliliters",
}

export enum ConsumableCadence {
  Never = "NEVER",
  EveryService = "EVERY_SERVICE",
  Every2ndService = "EVERY_2ND_SERVICE",
  OncePerYear = "ONCE_PER_YEAR",
}

export enum PropertyUnit {
  None = "none",
  MonthlyHours = "hours/month",
  Weeks = "weeks",
  Hours = "hours",
  TimesPerYear = "times/year",
}

export enum PropertyType {
  None = "none",
  Time = "time",
  TimeFraction = "time-fraction",
  TimeAfter = "time-after",
  TimePeriod = "time-period",
}
